// External Imports
import { useContext } from "react";

// Internal Imports
import { UtilityContext } from "../../context/util-context";
import { truncate } from "../../util/format-text";
import { isoDateToString } from "../../util/format-date";

/** ========================================================================
 * * MaintenanceCard Component
 * This component renders a card to display mainteance summary.
 * ========================================================================== */

export default function MaintenanceCard({ item: log }) {
  const { navigate } = useContext(UtilityContext);

  const itemClasses = (item) => {
    let classes = "pill grid lg:grid-cols-6";
    if (item.priority === 0) classes += " border-yellow-800";
    if (item.priority === 1) classes += " border-blue-800";
    if (item.priority === 2) classes += " border-red-800";
    return classes;
  };
  return (
    <div
      className={itemClasses(log)}
      onClick={() => navigate(`/maintenance/info?id=${log.id}`)}
    >
      <img src={log.vehicle?.image} className="h-12" />

      <p className="">
        {log.vehicle.model} {" "}
        {log.vehicle.year}
        {" - "}
        {log.vehicle.vin.substring(13, 17)}{" "}
      </p>
      <p className="text-stone-400">
        {isoDateToString(log.dateCreated)} - {isoDateToString(log.dateCompleted)}
      </p>
      <p className="font-semibold text-stone-200">
        {log.status.toUpperCase().replace("-", " ")}
      </p>
      <p className="lg:col-span-2 text-stone-400">{log.description}</p>
    </div>
  );
}
